export default "__VITE_ASSET__23e9fd15__"